<button
  class="btn btn-sm btn-primary"
  *ngIf="checkIfCanReviewChangeRequests()"
  (click)="OnReviewClicked.emit(changeRequest.id)">
  <i class="fas fa-search"></i> Review
</button>
